import {InputRule} from "prosemirror-inputrules";
import {NodeSelection} from "prosemirror-state";

const marksBetween = (start, end, state) => {
    let marks = [];

    state.doc.nodesBetween(start, end, (node, pos) => {
        marks = [
            ...marks,
            ...node.marks.map(mark => ({
                start: pos,
                end: pos + node.nodeSize,
                mark,
            })),
        ];
    });

    return marks;
}

export const markInputRule = (regexp, markType, getAttrs) => {
    return new InputRule(regexp, (state, match, start, end) => {
        const attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
        const {tr} = state;
        const m = match.length - 1;
        let markEnd = end;
        let markStart = start;
        if (match[m]) {
            const matchStart = start + match[0].indexOf(match[m - 1]);
            const matchEnd = matchStart + match[m - 1].length - 1;
            const textStart = matchStart + match[m - 1].lastIndexOf(match[m]);
            const textEnd = textStart + match[m].length;

            const excludedMarks = marksBetween(start, end, state)
                .filter(item => item.mark.type.excludes(markType))
                .filter(item => item.end > matchStart);

            if (excludedMarks.length) {
                return null;
            }

            if (textEnd < matchEnd) {
                tr.delete(textEnd, matchEnd);
            }
            if (textStart > matchStart) {
                tr.delete(matchStart, textStart);
            }
            markStart = matchStart;
            markEnd = markStart + match[m].length;
        }

        tr.addMark(markStart, markEnd, markType.create(attrs));
        tr.removeStoredMark(markType);
        return tr;
    })
}

export const textBlockTypeInputRuleWithSelection = (pattern, nodeType, getAttrs) => {
    return new InputRule(pattern, (state, match, start, end) => {
        let $start = state.doc.resolve(start)
        let attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs
        if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) return null
        let tr = state.tr
            .delete(start, end)
            .setBlockType(start, start, nodeType, attrs);

        return tr.setSelection(NodeSelection.create(
            tr.doc, tr.mapping.map($start.pos - 1)
        ));
    })
}